export default __webpack_public_path__ + "static/media/star_goal.f72ce9f0.svg";